<template>
  <div class="top-of-the-day-root">
    <vs-popup
      :active.sync="isActive"
      @update:active="handlePopupUpdate"
      title="Gün Açılışı"
      class="top-of-day-opening-popup"
      :button-close-hidden="true"
    >
      <vs-row vs-type="flex" vs-w="12" class="mt-4">
        <vs-col vs-type="flex" vs-w="12" vs-justify="center">
          <h3>Lütfen kasadaki mevcut nakit miktarını sayarak gün açılışını yapınız.</h3>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-4">
        <vs-col vs-type="flex" vs-w="12" vs-justify="center">
          <vs-input
            id="Nakit"
            name="Nakit"
            v-validate="'required'"
            v-model="safeCash"
            label-placeholder="Kasa Anlık Nakit: "
            @input="handleInput"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-4">
        <vs-col vs-type="flex" vs-w="12" vs-justify="center">
          <span style="text-align: center;" class="text-danger text-sm" v-show="errors.has('Nakit')">{{
            errors.first('Nakit')
          }}</span>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-4">
        <vs-col vs-type="flex" vs-w="12" vs-justify="center" class="top-of-day-main-actions">
          <vs-button @click="showPopup" size="large" color="transparent" class="bold bg-success text-white top-of-day-main-btn">
            Onayla
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>

    <vs-popup
      :active.sync="showPopupFlag"
      title="Nakit tutarı onayı"
      class="top-of-day-zero-cash-confirm"
    >
      <div class="top-of-day-confirm__body">
        <p class="top-of-day-confirm__message">
          Kasa açılış nakit miktarı <strong>{{ safeCash }}</strong> TL olarak kaydedilecektir, onaylıyor musunuz?
        </p>
        <div class="top-of-day-confirm__actions">
          <vs-button type="filled" color="success" class="top-of-day-confirm__btn" @click="forcelose">
            Onaylıyorum
          </vs-button>
          <vs-button type="border" color="danger" class="top-of-day-confirm__btn top-of-day-confirm__btn-cancel" @click="closePopup">
            İptal
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { createDayOpen } from '@/api/DayOpen.js';
import companyInfo from '../../../model/constants/companyInfo';

export default {
  data() {
    return {
      isActive: false,
      logo: companyInfo.logo,
      showPopupFlag: false,
      safeCash: 0,
      allowTopOfDayClose: false
    };
  },
  computed: {
    activePersonel: function () {
      return this.$store.getters['selfservice/getActivePersonal'];
    }
  },
  methods: {
    handleInput() {
      if (this.safeCash !== null) {
        const regex = /^\d+(\.\d{0,2})?$/;
        if (!regex.test(this.safeCash)) {
          this.safeCash = this.safeCash.slice(0, -1);
        }
      }
    },
    showPopup: async function () {
      const checker = await this.$validator.validateAll();
      if (!checker) {
        return;
      }
      this.showPopupFlag = true;
    },
    closePopup() {
      this.showPopupFlag = false;
    },
    forcelose: async function () {
      this.showPopupFlag = false;
      try {
        await createDayOpen({
          safeCash: this.safeCash,
          userId: this.activePersonel.id,
          userName: this.activePersonel.name
        });
        this.$vs.notify({
          color: 'success',
          title: 'Gün açılışı',
          text: 'Kayıt tamamlandı.'
        });
        this.$emit('emitGetBranchOpenClose', true);
        this.allowTopOfDayClose = true;
        this.isActive = false;
        this.$nextTick(() => {
          this.allowTopOfDayClose = false;
        });
      } catch (error) {
        const data = error.response && error.response.data;
        const list = data && (data.Errors || data.errors);
        const row = list && list[0];
        const apiMsg = row && (row.Message || row.message);
        this.$vs.notify({
          color: 'danger',
          title: 'Hata',
          text: apiMsg || error.message || 'İşlem başarısız.'
        });
      }
    },
    handlePopupUpdate(newValue) {
      if (!newValue) {
        this.showPopupFlag = false;
        if (this.allowTopOfDayClose) {
          return;
        }
        this.$nextTick(() => {
          this.isActive = true;
        });
      }
    }
  }
};
</script>

<style scoped>
.top-of-the-day-root {
  display: block;
}

.top-of-day-confirm__body {
  padding: 1.35rem 1.5rem 1.5rem;
  text-align: center;
  max-width: 24rem;
  margin: 0 auto;
  box-sizing: border-box;
}

.top-of-day-confirm__message {
  margin: 0 0 1.35rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #3a2a28;
  font-weight: 600;
}

.top-of-day-confirm__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: center;
  align-items: center;
}

.top-of-day-confirm__btn {
  flex: 1 1 auto;
  min-width: 7.5rem;
  font-weight: 700 !important;
}

.top-of-day-main-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: center;
  align-items: center;
}

.top-of-day-main-btn {
  min-width: 7.5rem;
}

.top-of-day-confirm__btn-cancel.vs-button-border ::v-deep .vs-button--text {
  color: #7f1010 !important;
}

.top-of-day-confirm__btn-cancel.vs-button-border {
  border-color: #c62828 !important;
}

.top-of-day-confirm__btn-cancel:hover ::v-deep .vs-button--text {
  color: #4a0a0a !important;
}
</style>

<style>
/* Gün Açılışı: X butonu (prop yetersiz kalırsa) + overlay ile kapanmayı handlePopupUpdate engeller */
.con-vs-popup.top-of-day-opening-popup .vs-popup--close,
.con-vs-popup.top-of-day-opening-popup .vs-popup--close--icon {
  display: none !important;
  pointer-events: none !important;
}

/* vs-popup body’ye taşınır; z-index scoped’tan uygulanmaz */
.con-vs-popup.top-of-day-zero-cash-confirm {
  z-index: 130000 !important;
}

.top-of-day-zero-cash-confirm.vs-popup-primary .vs-popup--content {
  padding: 0 !important;
}

.logo {
  background-color: white;
  border-radius: 10px;
  margin-bottom: 1rem;
}
#switchScreen {
  z-index: 999999;
}
#switchScreen .vs-popup .vs-popup--header {
  display: none !important;
}

#switchScreen .vs-popup .vs-popup--content {
  padding: 0 !important;
}

#switchScreen .vs-popup {
  background: transparent !important;
  box-shadow: none !important;
}

#switchScreen input {
  font-size: 2rem !important;
  background: #f2f2f2 0% 0% no-repeat padding-box !important;
  text-align: center !important;
  padding: 0.5rem;
}
</style>
